import { createReducer, on } from "@ngrx/store";
import {
  sendInviteTeacher,
  sendInviteTeacherFail,
} from "../../actions/admin/send-invite-teacher.actions";
import { invitedTeachersListPost } from "../../actions/admin/invited-teachers.actions";
import { InvitationsRequest } from "src/app/shared/interfaces/invitations-request";

export interface SendInviteTeacherState {
  sendInvitationsFailed: boolean;
  sendInvitationsPending: boolean;
  error: InvitationsRequest | null;
}

const initialState: SendInviteTeacherState = {
  sendInvitationsFailed: false,
  sendInvitationsPending: false,
  error: null,
};

export const sendInviteTeacherReducer = createReducer(
  initialState,
  on(
    sendInviteTeacher,
    (state): SendInviteTeacherState => ({
      ...state,
      sendInvitationsFailed: false,
      sendInvitationsPending: true,
      error: null,
    }),
  ),
  on(
    invitedTeachersListPost,
    (state): SendInviteTeacherState => ({
      ...state,
      sendInvitationsPending: false,
    }),
  ),
  on(
    sendInviteTeacherFail,
    (state, { error }): SendInviteTeacherState => ({
      ...state,
      sendInvitationsFailed: true,
      sendInvitationsPending: false,
      error,
    }),
  ),
);
